(() => {
  const style = document.createElement('style');
  style.id = 'blacktie-realift-bridge-styles';
  style.textContent = [
    'realift-app, #headlessui-portal-root { display: none !important; }',
    '#find-my-size-drawer .blacktie-find-size-content:has([id^="headlessui-popover-panel-"]) { overflow: visible !important; }',
    '#find-my-size-drawer .blacktie-realift-option { position: relative; isolation: isolate; }',
    '#find-my-size-drawer .blacktie-realift-option #blacktie-realift-legacy { position: absolute; inset: 0; z-index: 2; width: 100%; height: 100%; }',
    '#find-my-size-drawer #blacktie-realift-legacy > [class*="App-module_realift"] { position: relative; width: 100%; height: 100%; }',
    '#find-my-size-drawer #blacktie-realift-legacy [id^="headlessui-popover-button-"] { position: absolute; inset: 0; width: 100%; height: 100%; }',
    '#find-my-size-drawer #blacktie-realift-legacy [id^="headlessui-popover-button-"] > button { display: block; width: 100%; height: 100%; margin: 0 !important; padding: 0 !important; opacity: 0 !important; cursor: pointer; }',
    '#find-my-size-drawer #blacktie-realift-legacy > [class*="App-module_realift"] > button { position: absolute !important; inset: 0 !important; display: block !important; width: 100% !important; height: 100% !important; margin: 0 !important; padding: 0 !important; opacity: 0 !important; cursor: pointer; }',
    '#find-my-size-drawer .blacktie-realift-option:focus-within { outline: 2px solid currentColor; outline-offset: 2px; }',
    '#find-my-size-drawer .blacktie-realift-option [id^="headlessui-popover-panel-"] { position: fixed !important; z-index: 50 !important; box-sizing: border-box; max-width: none !important; margin: 0 !important; padding: 16px 20px 32px !important; transform: none !important; border: 0 !important; border-radius: 0 !important; box-shadow: none !important; background: #faf9f7 !important; color: #111 !important; overflow-y: auto !important; }',    '#find-my-size-drawer .blacktie-realift-option [class*="App-module_vessel"] { box-sizing: border-box; width: 100% !important; max-width: none !important; margin: 0 !important; padding: 0 !important; border: 0 !important; box-shadow: none !important; background: transparent !important; }',
    '#find-my-size-drawer .blacktie-realift-option [class*="App-module_close"] { display: none !important; }',
    '#find-my-size-drawer .blacktie-realift-back { display: block; margin: 0 0 24px; padding: 0; border: 0; background: transparent; color: #111; font: inherit; cursor: pointer; }',
    '#find-my-size-drawer .blacktie-realift-option [id^="headlessui-popover-panel-"] h4 { font-family: var(--font-heading-family, Georgia, serif); font-size: 24px; font-weight: 600; line-height: 1.25; color: #111; }',
    '#find-my-size-drawer .blacktie-realift-option [id^="headlessui-popover-panel-"] p { font-family: var(--font-body-family, Arial, sans-serif); line-height: 1.5; color: #4b4b4b; }',
        '#find-my-size-drawer .blacktie-realift-option [id^="headlessui-popover-panel-"] .text-center.mt-3 ._flex.justify-evenly > button.btn.align-middle { display: inline-flex !important; align-items: center !important; justify-content: center !important; min-width: 180px; min-height: 48px; padding: 12px 24px !important; border: 1px solid #a9a9a9 !important; border-radius: 0 !important; background: #fff !important; color: #1f1f1f !important; font-family: var(--font-body-family, Arial, sans-serif) !important; font-size: 14px !important; font-weight: 600 !important; text-transform: uppercase; box-shadow: none !important; cursor: pointer; }',
    '#find-my-size-drawer .blacktie-realift-option [id^="headlessui-popover-panel-"] button { cursor: pointer; }'
  ].join('\n');
  document.head.append(style);

  let disposeBridge = () => {};
  let currentRoot = null;

  function bindCurrentDrawer(force = false) {
  const card = document.querySelector('#find-my-size-drawer .blacktie-realift-option');
  const root = card?.querySelector('#blacktie-realift-legacy');
  const dialog = card?.closest('dialog');
  if (!force && root === currentRoot) return;
  disposeBridge();
  currentRoot = root;
  disposeBridge = () => {};
  if (!card || !root || !dialog) return;
  const listeners = new AbortController();
  const listenerOptions = { signal: listeners.signal };

  const title = card.querySelector('.blacktie-find-size-option__title');
  const description = card.querySelector('.blacktie-find-size-option__description');
  const sdkButton = () => root.querySelector('[id^="headlessui-popover-button-"] > button, [class*="App-module_realift"] > button');
  const sdkPanel = () => root.querySelector('[id^="headlessui-popover-panel-"]');
  root.removeAttribute('aria-hidden');
    const retryKey = 'blacktie-realift-retry:' + location.pathname;
  const qrKey = 'blacktie-realift-qr:' + location.pathname;
  let retrying = sessionStorage.getItem(retryKey) === '1';
let qrSeen = sessionStorage.getItem(qrKey) === '1' ||
  (retrying && window.matchMedia('(max-width: 767px)').matches);
    [...card.children].filter(child => child !== root).forEach(child => child.setAttribute('aria-hidden', 'true'));

  let drawerClosing = false;

  function positionPanel() {
    const panel = sdkPanel();
    if (!panel || !dialog.open || drawerClosing) return;
    panel.style.setProperty('position', 'absolute', 'important');

    if (!panel.querySelector('.blacktie-realift-back')) {
      const back = document.createElement('button');
      back.type = 'button';
      back.className = 'blacktie-realift-back';
      back.textContent = '← Back';
      back.addEventListener('click', () => sdkButton()?.click());
      panel.prepend(back);
    }

    const drawerRect = dialog.getBoundingClientRect();
    const header = dialog.querySelector('.theme-drawer__header');
    const top = header?.getBoundingClientRect().bottom || drawerRect.top;
    const height = drawerRect.bottom - top;

    const anchor = panel.offsetParent || dialog;
    const anchorRect = anchor.getBoundingClientRect();
    panel.style.setProperty('left', (drawerRect.left + dialog.clientLeft -
      anchorRect.left - anchor.clientLeft) + 'px', 'important');
    panel.style.setProperty('top', (top - anchorRect.top - anchor.clientTop) + 'px', 'important');
    panel.style.setProperty('width', dialog.clientWidth + 'px', 'important');
    panel.style.setProperty('height', height + 'px', 'important');
    panel.style.setProperty('max-height', height + 'px', 'important');
    panel.style.setProperty('background', getComputedStyle(dialog).backgroundColor, 'important');
  }

  function renameTorso() {
    const panel = sdkPanel();
    if (!panel) return;
    const walker = document.createTreeWalker(panel, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.textContent.trim() === 'Upper Body') {
        node.textContent = node.textContent.replace('Upper Body', 'Upper Body Torso');
      }
    }
  }
function addContinueButton() {
  const panel = sdkPanel();
  if (!panel || panel.querySelector('.blacktie-realift-continue')) return;

  const retry = [...panel.querySelectorAll('button')].find(
    button => button.textContent.trim().toLowerCase() === 'try again'
  );
  if (!retry) return;

  const next = document.createElement('button');
  next.type = 'button';
  next.className = retry.className + ' blacktie-realift-continue';
  next.textContent = 'Continue';
  next.setAttribute('aria-label', 'Continue to product');
  next.addEventListener('click', () => {
    dialog.querySelector('.theme-drawer__close-button')?.click();
  });

  retry.insertAdjacentElement('afterend', next);
  retry.parentElement.style.display = 'flex';
  retry.parentElement.style.gap = '12px';

  [retry, next].forEach(button => {
    button.style.setProperty('flex', '1 1 0', 'important');
    button.style.setProperty('min-width', '0', 'important');
  });
}
  function sync() {
    addContinueButton();
    renameTorso();
    const button = sdkButton();
    if (!button) return;
    const match = button.textContent.match(/Suggested Size:\s*(.+)/i);
const rawSize = match?.[1]?.trim();
const shirtSize = rawSize?.match(
  /^(\d+(?:\.\d+)?)\s*(?:\/\s*)?(\d+\s*[-–]\s*\d+)$/
);

const formattedSize = shirtSize
  ? `${Number(shirtSize[1])} / ${shirtSize[2]
      .replace(/\s+/g, '')
      .replace('–', '-')}`
  : rawSize?.toUpperCase();

        const panelText = sdkPanel()?.textContent || '';
    if (retrying && /Welcome to the Virtual Size Finder/i.test(panelText)) {
      qrSeen = true;
      sessionStorage.setItem(qrKey, '1');
    }
        if (retrying && qrSeen && /Your Measurements:/i.test(panelText)) {
      retrying = false;
      qrSeen = false;
      sessionStorage.removeItem(retryKey);
      sessionStorage.removeItem(qrKey);
    }
    const fit = retrying ? null : formattedSize;
    title.textContent = fit ? 'Your Fit: ' + fit : 'Use Your Phone';
    description.textContent = fit ? 'Click to see your results' : "Get measured using your phone's camera.";
    document.querySelectorAll('button.blacktie-find-my-size[aria-controls="find-my-size-drawer"]').forEach(productButton => {
      const label = [...productButton.childNodes].find(node =>
        node.nodeType === Node.TEXT_NODE && /FIND MY SIZE|Your Fit:/i.test(node.textContent)
      );
      if (label) label.textContent = fit ? ' Your Fit: ' + fit + ' ' : ' FIND MY SIZE ';
    });
    button.setAttribute('aria-label', fit ? 'Your Fit: ' + fit + '. Click to see your results' : 'Use Your Phone. Start guided scan');
    positionPanel();
  }
  function reopenDrawer() {
    if (dialog.isConnected && !dialog.open) {
      document.querySelector(
        'button.blacktie-find-my-size[aria-controls="find-my-size-drawer"]'
      )?.click();
    }
  }

  root.addEventListener('click', event => {
    const clicked = event.target instanceof Element
      ? event.target.closest('button')
      : null;
    if (clicked?.textContent.trim().toLowerCase() !== 'try again') return;

    retrying = true;
    qrSeen = window.matchMedia('(max-width: 767px)').matches;
    sessionStorage.setItem(retryKey, '1');
        sessionStorage.removeItem(qrKey);
    setTimeout(() => {
      sync();
      reopenDrawer();
    }, 250);
  }, { capture: true, signal: listeners.signal });

  if (retrying) {
    if (document.readyState === 'complete') {
      setTimeout(reopenDrawer, 250);
    } else {
      window.addEventListener('load', () => setTimeout(reopenDrawer, 250), {
        once: true, signal: listeners.signal
      });
    }
  }
  const rootObserver = new MutationObserver(sync);
  rootObserver.observe(root, { childList: true, subtree: true, characterData: true });
  window.addEventListener('resize', sync, listenerOptions);
  dialog.addEventListener('animationend', positionPanel, listenerOptions);
  dialog.addEventListener('transitionend', positionPanel, listenerOptions);
  const dialogObserver = new MutationObserver(positionPanel);
  dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open', 'class'] });
  // Dock the SDK panel to the drawer while it slides out, so both move together.
  dialog.closest('theme-drawer')?.addEventListener('theme-drawer:close', () => {
    drawerClosing = true;
    const panel = sdkPanel();
    if (!panel) return;
    const drawerRect = dialog.getBoundingClientRect();
    const header = dialog.querySelector('.theme-drawer__header');
    const top = header?.getBoundingClientRect().bottom || drawerRect.top;
    panel.style.setProperty('position', 'absolute', 'important');
    const anchor = panel.offsetParent || dialog;
    const anchorRect = anchor.getBoundingClientRect();
    panel.style.setProperty('left', (drawerRect.left + dialog.clientLeft -
      anchorRect.left - anchor.clientLeft) + 'px', 'important');
    panel.style.setProperty('top', (top - anchorRect.top - anchor.clientTop) + 'px', 'important');
  }, listenerOptions);
  dialog.closest('theme-drawer')?.addEventListener('theme-drawer:open', () => {
    drawerClosing = false;
    positionPanel();
  }, listenerOptions);
  dialog.addEventListener('close', () => {
    if (sdkPanel()) sdkButton()?.click();
    drawerClosing = false;
  }, listenerOptions);
  disposeBridge = () => {
    listeners.abort();
    rootObserver.disconnect();
    dialogObserver.disconnect();
  };
  sync();
  }

  // Rebind when Horizon replaces the product drawer after a color change.
  let bindingScheduled = false;
  const productObserver = new MutationObserver(() => {
    if (bindingScheduled) return;
    bindingScheduled = true;
    requestAnimationFrame(() => {
      bindingScheduled = false;
      bindCurrentDrawer();
    });
  });
  productObserver.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener("blacktie:realift-mounted", () => bindCurrentDrawer(true));
  bindCurrentDrawer();
})();